import { ChatWorkspace } from '@pwa/components/chat/chat-workspace';
import { createFileRoute } from '@tanstack/react-router';
import { generateId } from 'better-auth';
import { useMemo } from 'react';

export const Route = createFileRoute('/_dashboard/org/$orgId/ws/$wsId/')({
	component: RouteComponent,
});

function RouteComponent() {
	const id = useMemo(() => generateId(8), []);

	return <ChatWorkspace chatId={id} initialMessages={[]} session={{ kind: 'draft' }} />;
}
